import { SwingPage } from '../components/ModelPages';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Swing | Cartwheel',
  'Swing generates and edits human motion from text and poses, creating smooth performances and motion datasets rapidly and at scale.',
);

export default SwingPage;
